/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {}
 */
export interface PublishedSchemaSearchRequest {
    /** The filter to apply to the search. */
    filter?: Truvity.PublishedSchemaFilter[];
    /** The sort order to apply to the search. */
    sort?: Truvity.PublishedSchemaSort[];
}
